import { faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from 'cn';

interface SurveyResponseSelectItemProps {
  app?: 'manager' | 'survey';
  value: string;
  tag?: string;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  isDragAndDrop?: boolean;
  label: string;
  ref?: React.Ref<HTMLButtonElement>;
}

function ProjectResponseSelectItem({
  app,
  tag,
  selected = false,
  onClick,
  disabled,
  isDragAndDrop,
  label,
  ref,
}: SurveyResponseSelectItemProps) {
  const buttonContent = (
    <>
      <div className='flex items-center gap-2'>
        {isDragAndDrop ? (
          <FontAwesomeIcon
            icon={faGripDotsVertical}
            className='size-4 text-gray-400'
          />
        ) : null}
        <div
          className={cn(
            'text-start',
            app ? '[font-family:var(--brand-font)]' : 'font-sans'
          )}
        >
          {label}
        </div>
      </div>
      <div className='inline-flex min-w-5 flex-col items-center justify-center gap-2 rounded-sm border border-gray-200 bg-gray-50 px-1 py-0.5'>
        <div className='min-w-4 text-center font-sans text-xs/none text-gray-900'>
          {tag}
        </div>
      </div>
    </>
  );

  if (app) {
    return (
      <button
        data-type={isDragAndDrop ? 'drag-and-drop' : 'select'}
        data-selected={selected}
        onClick={onClick}
        disabled={disabled}
        ref={ref}
        data-test='select-item-button'
        className='flex min-h-10 w-full items-center justify-between rounded-lg border border-(--brand-separation-border) bg-white px-3 [font-family:var(--brand-font)] shadow-(--brand-separation-shadow) active:ring-2 active:ring-sky-300 data-[selected=true]:border-none data-[selected=true]:bg-(--brand-primary) data-[selected=true]:text-(--brand-primary-contrast) data-[selected=true]:shadow-xl data-[type=drag-and-drop]:bg-(--brand-primary) data-[type=drag-and-drop]:text-(--brand-primary-contrast) data-[type=drag-and-drop]:shadow-none data-[type=drag-and-drop]:active:rotate-1'
      >
        {buttonContent}
      </button>
    );
  }

  return (
    <div
      data-type={isDragAndDrop ? 'drag-and-drop' : 'select'}
      data-selected={selected}
      className='flex min-h-10 w-full items-center justify-center rounded-[9px] bg-linear-to-r from-rose-100 to-indigo-100 hover:from-rose-200 hover:to-indigo-200 active:from-rose-400 active:to-indigo-400 data-[selected=true]:from-rose-400 data-[selected=true]:to-indigo-400 data-[type=drag-and-drop]:active:rotate-1'
      data-test='select-item'
    >
      <button
        onClick={onClick}
        className='relative m-auto flex size-[calc(100%-2px)] items-center justify-between gap-4 self-stretch rounded-lg bg-linear-to-r from-rose-50 to-indigo-50 px-3 transition-all hover:from-rose-100 hover:to-indigo-100 active:from-rose-100 active:to-indigo-100 active:ring-2 active:ring-sky-300 data-[selected=true]:from-rose-200 data-[selected=true]:to-indigo-200 data-[type=drag-and-drop]:active:from-rose-200 data-[type=drag-and-drop]:active:to-indigo-200 data-[type=drag-and-drop]:active:ring-0'
        data-selected={selected}
        data-type={isDragAndDrop ? 'drag-and-drop' : 'select'}
        disabled={disabled}
        ref={ref}
        data-test='select-item-button'
      >
        {buttonContent}
      </button>
    </div>
  );
}

export default ProjectResponseSelectItem;
